import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login',
    component: () => import('@/views/login/index'),

  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index'),
  },
  {
    path: '/loanHistory',
    name: 'loanHistory',
    component: () => import('@/views/loanHistory/index'),
  },
  {
    path: '/loanDetails',
    name: 'loanDetails',
    component: () => import('@/views/loanDetails/index'),
  },
  {
    path: '/loanAgreement',
    name: 'loanAgreement',
    component: () => import('@/views/loanAgreement/index'),
  },
  {
    path: '/loan',
    name: 'loan',
    component: () => import('@/views/loan/index'),
  },
  {
    path: '/guide',
    name: 'guide',
    component: () => import('@/views/guide/index'),
  },
  {
    path: '/code',
    name: 'code',
    component: () => import('@/views/code/index'),
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('@/views/terms/index'),

  },
  {
    path: '/certificate',
    name: 'certificate',
    component: () => import('@/views/certificate/index'),

  },
  {
    path: '/extend',
    name: 'extend',
    component: () => import('@/views/extend/index'),

  },
  {
    path: '/repayment',
    name: 'repayment',
    component: () => import('@/views/repayment/index'),

  },
  {
    path: '/repaymentWay',
    name: 'repaymentWay',
    component: () => import('@/views/repaymentWay/index'),
  },
  {
    path: '/repaymentDetails',
    name: 'repaymentDetails',
    component: () => import('@/views/repaymentDetails/index'),
  },
  {
    path: '/yourself',
    name: 'yourself',
    component: () => import('@/views/yourself/index'),
  },
  {
    path: '/Receiving',
    name: 'Receiving',
    component: () => import('@/views/Receiving/index'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/privacy/index'),
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('@/views/order/index'),
  },
  {
    path: '/Case',
    name: 'Case',
    component: () => import('@/views/Case/index'),
  },
  {
    path: '/orderDetails',
    name: 'orderDetails',
    component: () => import('@/views/orderDetails/index'),
  },
  {
    path: '/failed',
    name: 'failed',
    component: () => import('@/views/failed/index'),
  },
  {
    path: '/paymentCounter',
    name: 'paymentCounter',
    component: () => import('@/views/paymentCounter/index'),
  },
]

const router = new VueRouter({
  routes
})

// router.beforeEach((to, from, next) => {
//   let appId = localStorage.getItem("appCode")
//   document.title = `${appId}-${to.name}`
//   const pageName = to.name;
//   window.gtag("event", "page_view", {
//     page_title: pageName,
//   });
//   const enterTime = Date.now();
//   to.meta.leaveGuard = router.afterEach((to, from) => {
//     const stayTime = Date.now() - enterTime;
//     window.gtag("event", "stay_time", {
//       value: stayTime,
//       event_category: "timing",
//       event_label: pageName,
//     });
//     to.meta.leaveGuard();
//   });
//   next()

// })
export default router
